import Logger from 'utils/Logger'
import config from 'core/src/config'
import api from './api'

const openPDFUrl = (userType: UserType, pdfUrl: string) => {
  if (pdfUrl.startsWith('/documents/')) {
    // If the URL is protected by authentication, use the API to fetch the PDF, convert it to a Blob URL, and open it
    api
      .fetchPDF(userType, pdfUrl)
      .then((blobUrl) => blobUrl && window.open(blobUrl, '_blank'))
      .catch((error) => Logger.error('Error opening PDF:', error))
  } else {
    // If the URL is public, simply open it in a new tab
    window.open(
      `${config.ENV === 'dev' ? 'https://engie.int.cardiweb.com' : window.location.origin}/${pdfUrl}`,
      '_blank'
    )
  }
}

export default openPDFUrl
